import React from 'react'
import {RsvpInfoButton} from '../rsvp-info-button'
import {ClosedRegistrationButtonProps} from '.'

export const ClosedRegistrationButton: React.FC<ClosedRegistrationButtonProps> = ({
  closedRegistrationMessages,
  onClick,
}) => <RsvpInfoButton messages={closedRegistrationMessages} dataHook="closed-registration" onClick={onClick} />
